import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-success\"><path d=\"M874.052023 245.649086l60.339778 60.339779-543.058008 543.058008L330.994015 788.707094z\" fill=\"#0057ff\" p-id=\"2911\" /><path d=\"M149.979135 486.985004l301.698894 301.698894-60.339779 60.339778L89.639357 547.324783z\" fill=\"#0057ff\" p-id=\"2912\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol